export const createAction = (type, payload, config) => {
  const { onSuccess, onFailure, onComplete } = config || {};

  return {
    type,
    ...(payload ? { payload } : null),
    ...(config ? { config: { onSuccess, onFailure, onComplete } } : null),
  };
};
